import React, { useState } from 'react'
import { ReferenceField, TextField, List, Datagrid } from 'react-admin';
import { CardHeader, CardContent } from '@material-ui/core';
import SearchInput from '../SearchInput';
import GroupField from '../GroupField';
import BulkDeleteButton from '../BulkDeleteButton';

const EmployeeTypeList = ({ employeeType, isAdmin, actions, clientId, ...props }) => {
    const [filteredData, setFilteredData] = useState(employeeType || []);

    const hanldeFilteredData = (filteredData) => {
        setFilteredData(filteredData)
    }

    const searchFilters = <SearchInput searchKeys={["name"]} setFilteredData={hanldeFilteredData} />;

    let filter = {};
    if(clientId) {
        filter = {
            "client": clientId
        }
    }

    return (
        <>
            <div style={{ width: '90%' }}>
                <CardHeader title="List Types" />
                <CardContent>
                    {employeeType && (
                        <>
                            <List 
                                filter={filter}
                                filters={searchFilters}
                                actions={actions}
                                {...props}
                                resource="employeeTypes"
                                perPage={25}
                                empty={false}
                                sort={{ field: 'createdAt', order: 'DESC' }}
                            >
                                <Datagrid bulkActionButtons={<BulkDeleteButton resource="employeeTypes" />} sx={{ '& .RaDatagrid-headerCell': { fontWeight: 'bold' } }}>
                                    <TextField source="name" label="Employee Type" />
                                    {isAdmin && (
                                        <ReferenceField label="Company" source="client" reference="clients" link={false}>
                                            <TextField source="companyName" />
                                        </ReferenceField>
                                    )}
                                    <TextField source="credit" label="Credit" />
                                    <GroupField label="Actions" basePath={props.basePath} />
                                </Datagrid>
                            </List>
                        </>
                    )}
                </CardContent>
            </div>
        </>
    )
}

export default EmployeeTypeList;
